__turbopack_context__.v({
  "active": "_4BfOFG_active",
  "bigLogo": "_4BfOFG_bigLogo",
  "burgerButton": "_4BfOFG_burgerButton",
  "buttonText": "_4BfOFG_buttonText",
  "buttons": "_4BfOFG_buttons",
  "de": "_4BfOFG_de",
  "desktopLangToggle": "_4BfOFG_desktopLangToggle",
  "drawerMenuLinks": "_4BfOFG_drawerMenuLinks",
  "en": "_4BfOFG_en",
  "grow": "_4BfOFG_grow",
  "headerLarge": "_4BfOFG_headerLarge",
  "headerSmall": "_4BfOFG_headerSmall",
  "languageToggle": "_4BfOFG_languageToggle",
  "link": "_4BfOFG_link",
  "linkButton": "_4BfOFG_linkButton",
  "logo": "_4BfOFG_logo",
  "mobileLangToggle": "_4BfOFG_mobileLangToggle",
  "patientButton": "_4BfOFG_patientButton",
  "smallLogo": "_4BfOFG_smallLogo",
  "tabs": "_4BfOFG_tabs",
  "topBar": "_4BfOFG_topBar",
});
